import {
  MASTER_SET_JOB_STATUS,
  MASTER_SET_SCHOOL,
  MASTER_SET_SCHOOL_LOCATION,
  MASTER_SET_SKILL,
  MASTER_SET_JOB_POSITION,
  MASTER_SET_INTERVIEW_FORMS,
  MASTER_SET_OFFERING_LETTER_FORMS,
} from 'store/types';

export const storeJobPosition = (data) => {
  return {
    type: MASTER_SET_JOB_POSITION,
    payload: data,
  };
};

export const storeJobStatus = (data) => {
  return {
    type: MASTER_SET_JOB_STATUS,
    payload: data,
  };
};

export const storeSchool = (data) => {
  return {
    type: MASTER_SET_SCHOOL,
    payload: data,
  };
};

export const storeSchoolLocation = (data) => {
  return {
    type: MASTER_SET_SCHOOL_LOCATION,
    payload: data,
  };
};

export const storeSkill = (data) => {
  return {
    type: MASTER_SET_SKILL,
    payload: data,
  };
};

export const storeInterviewForms = (data) => {
  return {
    type: MASTER_SET_INTERVIEW_FORMS,
    payload: data,
  };
};

export const storeOfferingLetterForms = (data) => {
  return {
    type: MASTER_SET_OFFERING_LETTER_FORMS,
    payload: data,
  };
};
